document.addEventListener('DOMContentLoaded', function () {
  // Scroll reveal
  const revealEls = document.querySelectorAll('[data-sl-reveal]');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  revealEls.forEach(el => revealObserver.observe(el));

  // Gentle parallax on hero images
  const parallaxEls = document.querySelectorAll('[data-sl-parallax]');
  window.addEventListener('scroll', function () {
    parallaxEls.forEach(el => {
      const speed = el.dataset.slParallax || 0.15;
      const offset = window.scrollY * speed;
      el.style.transform = `translateY(${offset}px)`;
    });
  }, { passive: true });

  // Animated counters (for the generations / vineyards / cases stats)
  const counters = document.querySelectorAll('[data-sl-counter]');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.slCounter, 10);
      let current = 0;
      const step = Math.max(1, Math.floor(target / 60));
      const tick = () => {
        current += step;
        if (current >= target) { el.textContent = target; return; }
        el.textContent = current;
        requestAnimationFrame(tick);
      };
      tick();
      counterObserver.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(el => counterObserver.observe(el));
});